import './TextField.css'

export default function TextField(props) {
    var outline = props.outline || '1px';
    return (
        <div style = {{width: props.width, maxWidth: props.maxWidth || "", marginRight: 'auto', boxSizing: "border-box"}}>
            <input
                id={props.inputId}
                className="text-field"
                type="text"
                placeholder={props.placeholder}
                onKeyDown={props.onKeyDown}
                style={{width: "100%", maxWidth: "100%", fontSize: '16px', borderWidth: outline}}
            />
        </div>
    )
}